(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-semio-home-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProductCarousels = (root = document) => {
      root.querySelectorAll('[data-semio-product-carousel]').forEach((carousel) => {
        if (carousel.dataset.semioCarouselReady === 'true') return;
        carousel.dataset.semioCarouselReady = 'true';
        const rail = carousel.querySelector('[data-semio-product-rail]');
        const previous = carousel.querySelector('[data-semio-rail-prev]');
        const next = carousel.querySelector('[data-semio-rail-next]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const move = (direction) => rail.scrollBy({ left: direction * rail.clientWidth * 0.85, behavior: reducedMotion ? 'auto' : 'smooth' });
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
      });
    };

    const initializeTabs = (root = document) => {
      root.querySelectorAll('[data-semio-tabs]').forEach((list) => {
        if (list.dataset.ready) return;
        list.dataset.ready = 'true';
        list.setAttribute('role', 'tablist');
        const tabs = Array.from(list.querySelectorAll('[data-panel]'));
        const select = (active) => {
          tabs.forEach((tab) => {
            const selected = tab === active;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            tab.classList.toggle('is-active', selected);
            document.getElementById(tab.dataset.panel).hidden = !selected;
          });
        };
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.panel);
          const panel = document.getElementById(tab.dataset.panel);
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
          tab.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            select(tab);
          });
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (event.key === ' ') { event.preventDefault(); select(tab); }
            if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
          });
        });
        select(tabs[0]);
      });
    };
    const initialize = (root = document) => {
      initializeTabs(root);
      initializeProductCarousels(root);
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["semio-editorial-page"]) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/œ/g,'oe').replace(/[’']/g,' ');
  const init = root => root.querySelectorAll('.semio-editorial--stones').forEach(section => {
    const search = section.querySelector('[data-stone-search]');
    if (!search || search.dataset.ready) return;
    const input = search.querySelector('input');
    const cards = Array.from(section.querySelectorAll('[data-stone]'));
    const status = search.querySelector('[data-search-count]');
    const empty = search.querySelector('[data-search-empty]');
    if (!cards.length) return;
    const update = () => {
      const terms = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const match = terms.every(term => normalize(card.textContent).includes(term));
        card.hidden = !match;
        if (match) count++;
      });
      status.textContent = status.dataset.template.replace('[count]',String(count));
      empty.hidden = count !== 0;
    };
    input.addEventListener('input',update);
    search.querySelector('[data-search-clear]').addEventListener('click',() => { input.value='';update();input.focus(); });
    search.hidden = false;
    search.dataset.ready = 'true';
    update();
  });
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["semio-stones-colours"]) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/œ/g,'oe').replace(/[’']/g,' ');
  const init = root => root.querySelectorAll('[data-colour-guide]').forEach(section => {
    const tools = section.querySelector('[data-scg-tools]');
    if (!tools || tools.dataset.ready) return;
    const cards = [...section.querySelectorAll('[data-stone]')];
    if (!cards.length) return;
    const input = tools.querySelector('input');
    const filters = [...tools.querySelectorAll('[data-colour]')];
    const status = tools.querySelector('[data-scg-count]');
    let colour = 'all';
    const update = () => {
      const terms = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const match = (colour === 'all' || (card.dataset.colours || '').split(' ').includes(colour)) && terms.every(term => normalize(card.dataset.stone + ' ' + card.querySelector('h2').textContent + ' ' + (card.querySelector('.scg-tone')?.textContent || '')).includes(term));
        card.hidden = !match;
        if (match) count++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colour === colour)));
      status.textContent = status.dataset.template.replace('[count]',String(count));
      if (count === 1) status.textContent = status.textContent.replace('pierres et matières', 'pierre ou matière');
      tools.querySelector('[data-scg-empty]').hidden = count !== 0;
    };
    input.addEventListener('input', update);
    filters.forEach(button => button.addEventListener('click', () => {colour = button.dataset.colour; update();}));
    tools.querySelector('[data-scg-reset]').addEventListener('click', () => {colour='all'; input.value=''; update(); input.focus();});
    tools.dataset.ready = 'true'; tools.hidden = false; update();
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
